var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcClose32 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51504F",
    fillRule: "evenodd",
    d: "M17.886 16l5.724-5.724c.521-.521.521-1.364 0-1.885-.522-.522-1.364-.522-1.886 0L16 14.115 10.276 8.39c-.521-.522-1.364-.522-1.885 0-.521.521-.521 1.364 0 1.885L14.115 16l-5.724 5.724c-.521.521-.521 1.364 0 1.885.26.26.601.391.943.391.341 0 .682-.13.942-.39L16 17.884l5.724 5.724c.26.26.602.391.943.391.341 0 .683-.13.943-.39.521-.522.521-1.365 0-1.886L17.886 16z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcClose32, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_close_32.ee98c5ea.svg";
export { ForwardRef as ReactComponent };